module.exports = __webpack_public_path__ + "static/august-3-de5b9fd6084def47c92da1f45bd100d2.png";